// extracted by mini-css-extract-plugin
export default {"SearchBox":"SearchBox_SearchBox__UihOX","Light":"SearchBox_Light__HBJkz","FormControl":"SearchBox_FormControl__N5kQ+"};